<template>
<v-container fluid>
  <v-row>
    <v-col cols="12">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Typ szablonu
              </th>
              <th class="text-left">
                Czy wgrany?
              </th>
              <th class="text-left">
                Akcje
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in szablony" :key="item.typ">
              <td>{{item.typ_opis}}</td>
              <td><v-icon v-if="item.id > 0" color="success">fa-check</v-icon></td>
              <td><v-icon color="primary" @click="upload(item.typ)" class="mr-2">fa-upload</v-icon><v-icon color="success" v-if="item.id>0"  @click="download(item)">fa-download</v-icon></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
  <v-row>
    <v-dialog v-model="showUploadAgreeTemplate" width="768" persistent>
      <UploadAgreeTemplate  v-if="showUploadAgreeTemplate" :typ="selectedType" @close="closeUpload()" @uploaded="uploadedDone"></UploadAgreeTemplate>
    </v-dialog>
  </v-row>
</v-container>
</template>

<script>
import {settingsService} from "@/services";
import {mapActions} from "vuex";

import UploadAgreeTemplate from "@/components/admin/settings/UploadAgreeTemplate";

export default {
  name: "AgreeTempolates",
  components: {UploadAgreeTemplate},
  data() {
    return {
      szablony: [],
      showUploadAgreeTemplate: false,
      selectedType: 0
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions("alert", ["error", "success"]),
      uploadedDone(result) {
        this.selectedType = 0
        this.showUploadAgreeTemplate = false
        this.getData()
      },
    closeUpload()
    {
      this.showUploadAgreeTemplate = false
      this.selectedType = 0
    },
     getData() {
        settingsService.getAgreeTemplates().then(result=> {
            let templates = result.data.result
            let localTempltes = this.getDefaultSzablony()
            templates.forEach(x=> {
              let ll = localTempltes.find(z=>z.typ == x.type)
              if(ll)
              {
                ll.czy_wgrany = true
                ll.id = x.id
              }
            })
            this.szablony = localTempltes
        }).catch(() => {
          this.error('Bład pobierania wgranych zgód')
        })
     },
    upload(type)
    {
      this.selectedType = type
      this.showUploadAgreeTemplate = true
    },
    download(item)
    {
      let fileName = item.typ_opis+".docx";
      settingsService.getAgreeTemplate(item.typ).then(result => {
        let b64 = result.data.result
        let a = document.createElement("a"); //Create <a>
        a.href = "data:application/octet-stream;base64," + b64; //Image Base64 Goes here
        a.download = fileName; //File name Here
        a.setAttribute('target','_blank');
        a.click(); //Downloaded file
      }).catch(() => {
        this.error('Bład pobierania zgody')
      })
    },
     getDefaultSzablony() {
      return [
        {
          id: 0,
          typ_opis: 'Klauzula obowiązku informacyjnego',
          typ: 1,
          czy_wgrany: false
        },
        {
          id: 0,
          typ_opis: 'Zgoda na świadczenie zdrowotne',
          typ: 2,
          czy_wgrany: false
        },
        {
          id: 0,
          typ_opis: 'Zgoda na komunikacje email/sms',
          typ: 3,
          czy_wgrany: false
        },
        {
          id: 0,
          typ_opis: 'Zgoda opiekuna prawnego',
          typ: 5,
          czy_wgrany: false
        },
        {
          id: 0,
          typ_opis: 'Zgoda na informacje handlowe',
          typ: 6,
          czy_wgrany: false
        },
        {
          id: 0,
          typ_opis: 'Ankieta covid',
          typ: 4,
          czy_wgrany: false
        },
        {
          id: 0,
          typ_opis: 'Dokumentacja medyczna',
          typ: 7,
          czy_wgrany: false
        },
        {
          id: 0,
          typ_opis: 'Plan zdrowienia',
          typ: 9,
          czy_wgrany: false
        },
      ]
    }
  }
}
</script>

<style scoped>

</style>